// extracted by mini-css-extract-plugin
export var fadeGrow = "styles-module--fadeGrow--NpLCE";
export var fadeUp = "styles-module--fadeUp--wIEIt";
export var visible = "styles-module--visible--HV5S1";